import React from "react";

const leaders = [
    // {
    //     name: "Srini Pallia",
    //     title: "Chief Executive Officer & Managing Director",
    //     img: "/images/leaders/srini-pallia.jpg",
    // },
    // {
    //     name: "Nagendra P Bandaru",
    //     title: "Managing Partner and Global Head – Technology Services",
    //     img: "/images/leaders/nagendra-bandaru.jpg",
    // },
    // {
    //     name: "Suzanne Dann",
    //     title: "CEO – Americas 2",
    //     img: "/images/leaders/suzanne-dann.jpg",
    // },
    // {
    //     name: "Vinay Firake",
    //     title: "CEO – APMEA",
    //     img: "/images/leaders/vinay-firake.jpg",
    // },
    // {
    //     name: "Saurabh Govil",
    //     title: "Chief Human Resources Officer",
    //     img: "/images/leaders/saurabh-govil.jpg",
    // },
    // {
    //     name: "Aparna C. Iyer",
    //     title: "Chief Financial Officer",
    //     img: "/images/leaders/aparna-iyer.jpg",
    // },
    // {
    //     name: "Sanjeev Jain",
    //     title: "Chief Operating Officer",
    //     img: "/images/leaders/sanjeev-jain.jpg",
    // },
    // {
    //     name: "Malay Joshi",
    //     title: "CEO – Americas 1",
    //     img: "/images/leaders/malay-joshi.jpg",
    // },
    // {
    //     name: "Jasjit Singh Kang",
    //     title: "Managing Partner and Global Head – Business Process Services",
    //     img: "/images/leaders/jasjit-kang.jpg",
    // },
    {
        name: "Amit Kumar",
        title: "Managing Partner and Global Head – Consulting",
        img: "/images/leaders/amit-kumar.jpg",
    },
    {
        name: "Omkar Nisal",
        title: "CEO – Europe",
        img: "/images/leaders/omkar-nisal.jpg",
    },
    {
        name: "Srikumar Rao",
        title: "Managing Partner and Global Head – Engineering",
        img: "/images/leaders/srikumar-rao.jpg",
    },
    {
        name: "Hari Shetty",
        title: "Chief Strategist and Technology Officer",
        img: "/images/leaders/hari-shetty.jpg",
    },
];

const Leadership = () => {
    return (
        <div className="w-full text-gray-800">

            {/* HERO */}
            <section className="relative h-[420px] bg-black">
                <img
                    src="/images/company/leadership/hero.png"
                    alt="Leadership"
                    className="absolute inset-0 w-full h-full object-cover opacity-70"
                />
                <div className="relative max-w-7xl mx-auto px-6 h-full flex flex-col justify-center">
                    <span className="text-sm text-white opacity-80 mb-2">
                        Leadership
                    </span>
                    <h1 className="text-4xl md:text-5xl font-semibold text-white">
                        TechSPR leadership
                    </h1>
                </div>
            </section>

            {/* TABS */}
            <section className="bg-white py-10">
                <div className="flex justify-center gap-4">
                    {/* <button className="px-6 py-2 rounded-full border text-sm">
                        Board of Directors
                    </button>
                    <button className="px-6 py-2 rounded-full border text-sm">
                        Committees of Board
                    </button> */}
                    <button className="px-6 py-2 rounded-full bg-blue-900 text-white text-sm">
                        Executive Leadership
                    </button>
                </div>
            </section>

            {/* LEADERS GRID */}
            <section className="bg-white py-16 px-6">
                <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-14">

                    {leaders.map((leader, index) => (
                        <div key={index} className="text-center">
                            <div className="w-44 h-44 mx-auto rounded-full overflow-hidden bg-gray-200 mb-4">
                                <img
                                    src={leader.img}
                                    alt={leader.name}
                                    className="w-full h-full object-cover grayscale"
                                />
                            </div>
                            <h3 className="font-semibold text-lg">{leader.name}</h3>
                            <p className="text-sm text-gray-600 mt-1 px-4">
                                {leader.title}
                            </p>
                        </div>
                    ))}

                </div>
            </section>

            {/* FOOTER */}
            {/* <footer className="bg-purple-900 text-white text-sm py-6">
                <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center gap-4">
                    <p>© 2026 TechSPR</p>
                    <div className="flex gap-6">
                        <a href="#">Disclaimer</a>
                        <a href="#">Privacy</a>
                        <a href="#">Modern Slavery Statement</a>
                    </div>
                    <div className="flex gap-4">
                        <span>🌐</span>
                        <span>in</span>
                        <span>f</span>
                    </div>
                </div>
            </footer> */}

        </div>
    );
};

export default Leadership;
